export default __webpack_public_path__ + "static/media/game-vertical-skeleton.d9ce1556.jpg";